<mat-card class="mt-2" fxFlex="0 0 100%">
    <mat-card-content>
        <div fxFlex="1 1 100%" fxLayoutAlign="center" fxLayout="column wrap" fxLayoutAlign="center" class="mt-1 mb-1">
            <form
                #formDirective="ngForm"
                fxLayout="row wrap"
                (ngSubmit)="submitLink(formDirective)"
                [formGroup]="linkForm"
            >
                <div fxFlex="0 0 100%">
                    <mat-form-field fxFlex="0 1 100%">
                        <input
                            matInput
                            placeholder="Add link headline"
                            i18n-placeholder
                            formControlName="title"
                            required
                        />
                        <mat-error i18n>Title field is required!</mat-error>
                    </mat-form-field>
                    <div fxLayoutAlign="center center" fxFlex="0 0 40px" class="coursePlan-layout">
                        <app-language-selector
                            formControlName="language_id"
                            class="icon-resource-builder"
                            fxFlex="0 0 auto"
                        ></app-language-selector>
                    </div>
                    <div fxLayoutAlign="center center" fxFlex="0 0 40px" class="coursePlan-layout">
                        <app-media
                            #app_media
                            fxFlex="0 0 auto"
                            [simple]="true"
                            *ngIf="!linkForm.get('media_id')?.value"
                            formControlName="media_id"
                            [scope]="AppScope.MATERIAL"
                            dropLabel="Drop course plan image"
                            i18n-dropLabel="@@coursePlanImageDropzoneLabel"
                        ></app-media>
                    </div>
                </div>
                <app-image-view
                    class="mt-2 mb-2"
                    *ngIf="linkForm.get('media_id')?.value"
                    fxFlex="0 1 300px"
                    [media_id]="linkForm.get('media_id')?.value"
                    [proportional]="false"
                >
                    <button
                        class="remove-image"
                        mat-icon-button
                        color="warn"
                        *ngIf="linkForm.get('media_id').value as mediaId"
                        matTooltip="Remove image"
                        i18n-matTooltip
                        (click)="linkForm.get('media_id').setValue(null)"
                    >
                        <mat-icon class="md-24">delete_outline</mat-icon>
                    </button>
                </app-image-view>

                <mat-form-field fxFlex="0 1 100%" class="mb-4">
                    <input matInput placeholder="Link" type="url" i18n-placeholder formControlName="link" required />
                    <mat-error i18n>URL field is required!</mat-error>
                    <button
                        matTooltip="Open link in new tab"
                        i18n-matTooltip
                        [disabled]="!Utils.isUrl(linkForm.get('link').value)"
                        class="open-link"
                        mat-icon-button
                        matSuffix
                        (click)="goToLink(linkForm.get('link').value)"
                    >
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                </mat-form-field>

                <app-tag-chip-select
                    fxFlex="0 1 100%"
                    [resource_id]="resource?.id"
                    [language_id]="linkForm?.get('language_id').value"
                    formControlName="tag_ids"
                ></app-tag-chip-select>

                <app-category-chip-select
                    fxFlex="0 1 100%"
                    [resource_id]="resource?.id"
                    [language_id]="linkForm?.get('language_id').value"
                    formControlName="category_ids"
                    [type_id]="ResourceTypes.MATERIAL"
                ></app-category-chip-select>
                <mat-accordion fxFlex="0 1 100%" displayMode="flat">
                    <mat-expansion-panel #expansionPanel>
                        <mat-expansion-panel-header class="material-acc-header-explain">
                            <div *ngIf="!expansionPanel.expanded" i18n="@@contentDescription">Content description</div>
                            <mat-icon
                                matTooltip="A description of the material that will be visible above the link"
                                i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <app-text-editor
                                *ngIf="active"
                                fxFlex="1 1 95%"
                                title="Content description"
                                i18n-title
                                [showTemplates]="false"
                                formControlName="description"
                            ></app-text-editor>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion fxFlex="0 1 100%" displayMode="flat">
                    <mat-expansion-panel #expansionPanelDesc>
                        <mat-expansion-panel-header class="material-acc-header-explain">
                            <div *ngIf="!expansionPanelDesc.expanded" i18n="@@contentInformation">
                                Content information
                            </div>
                            <mat-icon
                                matTooltip="Extra information will be displayed under the material and used for specifications
                                like timestamps etc"
                                i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <app-text-editor
                                *ngIf="active"
                                fxFlex="1 1 95%"
                                title="Content information"
                                i18n-title
                                [showTemplates]="false"
                                formControlName="instructions"
                            ></app-text-editor>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion fxFlex="0 1 100%" displayMode="flat">
                    <mat-expansion-panel #expansionPanelPrio>
                        <mat-expansion-panel-header class="material-acc-header-explain">
                            <div *ngIf="!expansionPanelPrio.expanded" i18n="@@priority">Priority</div>
                            <mat-icon
                                matTooltip="Prio will determine the order that it will be displayed in sections"
                                i18n-matTooltip
                                >help_outline</mat-icon
                            >
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <mat-form-field fxFlex="1 1 95%">
                                <input
                                    matInput
                                    fxLayoutAlign="end center"
                                    type="number"
                                    placeholder="Please set priority"
                                    i18n-placeholder="@@plsSetPriority"
                                    formControlName="priority"
                                />
                            </mat-form-field>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>

                <app-media-view
                    fxLayoutAlign="center center"
                    *ngIf="mediaKey as mediaId"
                    fxFlex="0 0 100%"
                    [media_id]="mediaId"
                >
                </app-media-view>

                <div fxFlex="0 0 100%" fxLayout="row" fxLayoutAlign="end" fxLayoutGap=".5em">
                    <button
                        *ngIf="!(saving | async) && !publishOnly"
                        mat-raised-button
                        [disabled]="linkForm.invalid"
                        color="primary"
                        type="submit"
                        i18n="@@save"
                    >
                        Save
                    </button>

                    <button
                        *ngIf="!(saving | async) && (isAdmin$ | async) && !resource?.published"
                        mat-raised-button
                        [disabled]="linkForm.invalid"
                        (click)="submitLink(formDirective, true)"
                        color="primary"
                    >
                        {{ publishLabel }}
                    </button>
                    <app-saving-button *ngIf="saving | async"></app-saving-button>
                </div>
            </form>
        </div>
    </mat-card-content>
</mat-card>
